import { Link, LinkProps } from '@vcc-www/buttons';

const TextButton: React.FC<LinkProps & { children: string }> = ({
  disabled,
  onClick,
  children,
  ...props
}) => (
  <Link
    disabled={disabled}
    onClick={onClick}
    trackEventAction="button|click"
    trackEventLabel={children}
    arrow={null}
    {...props}
  >
    {children}
  </Link>
);

export default TextButton;
